module.exports = __webpack_public_path__ + "assets/img/logo_makou.ab7dfb3a.png";